/**
 * The zone this console acts on.
 *
 * A constant today because only the EU deployment exists, and read through one
 * place so that adding a second is a deployment change rather than a search
 * through the codebase.
 */
export const ZONE = "eu" as const;
